var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-button",class:{ 'button-reset': _vm.isResetButton, 'button-apply': _vm.isApplyButton, 'isBlocked': _vm.isBlocked },on:{"click":_vm.clickHandler}},[_c('div',{staticClass:"button-content"},[_vm._v("\n    "+_vm._s(_vm.buttonText)+" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88e21170","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/Inputs/ButtonWithIcon.vue
// module id = null
// module chunks = 